import React from "react";

const LoadingDots = () => {
  return (
    <div style={{ display: "flex", alignItems: "center", fontSize: "12px", margin: '0px', padding: '0px' }}>
      <span>Loading</span>
      <span className="dots">.</span>
      <span className="dots">.</span>
      <span className="dots">.</span>
    </div>
  );
};

export default LoadingDots;
